import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m5.417 4.583 3.416-3.416M9.167 2.833v-2h-2M4.584.833H3.75C1.667.833.833 1.667.833 3.75v2.5c0 2.083.834 2.917 2.917 2.917h2.5c2.084 0 2.917-.834 2.917-2.917v-.833"
    }, null, -1)
  ]))]))
}
export default { render: render }